import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import axios from "axios"
import { API_ROOT } from "gatsby-env-variables"
import whatsapp from "../assets/images/whatsapp.svg";
import instagram from "../assets/images/instagram.svg";
import wechat from "../assets/images/wechat.svg";
import facebook from "../assets/images/facebook.svg";

class footer extends React.Component {
    state = {}
    componentDidMount(){
        this.getSetting();
    }
    getSetting(){
        if(window.location.pathname.includes('/ch')){
            localStorage.setItem("lang", 'ch');
        } else {
            localStorage.setItem("lang", 'en');
        }
        var lang = localStorage.getItem("lang");
        this.setState({
            lang: lang
        })
        axios.get(API_ROOT+`/api/v1/settings`)
            .then( (response) => {
                if(response && response.data && response.data.data){
                    this.setState({
                        address: lang === 'en' ? response.data.data.address_en : response.data.data.address_chn,
                        mobile: lang === 'en' ? response.data.data.mobile_en[0] : response.data.data.mobile_chn[0],
                        phone: lang === 'en' ? response.data.data.phone_en[0] : response.data.data.phone_chn[0],
                        email: lang === 'en' ? response.data.data.email_en[0] : response.data.data.email_chn[0],
                        wechat: response.data.data.wechat,
                        wechatUsername: response.data.data.wechat_username,
                        whatsapp: response.data.data.whatsapp,
                        whatsappUsername: response.data.data.whatsapp_username,
                        facebook: response.data.data.facebook,
                        facebookUsername: response.data.data.facebook_username,
                        instagram: response.data.data.instagram,
                        instagramUsername: response.data.data.instagram_username
                    })
                }
            })
    }
    render() {
        return (
            <Col md={12}>
                <Col md={{span:10, offset:1}}>
                    <Row className={'pt13 pb13 white'}>
                        <Col className={'p0'} md={4}>
                            <p className={'footer-title'}>{this.state.lang === 'en' ? 'Address' : '地址' }:</p>
                            <p className={'footer-description'}>
                                {this.state.address}
                            </p>
                        </Col>
                        <Col className={'p0'} md={5}>
                            <p className={'footer-title'}>
                                {this.state.lang === 'en' ? 'Contact Us' : '联系我们' }:
                            </p>
                            <p  className={'footer-description'}>
                                <span> {this.state.lang === 'en' ? 'Mob' : '手机号码' }: </span> {this.state.mobile}
                            </p>
                            <p  className={'footer-description'}>
                                <span> {this.state.lang === 'en' ? 'Tel' : '电话号码' }: </span> {this.state.phone}
                            </p>
                            <p  className={'footer-description'}>
                                <span> {this.state.lang === 'en' ? 'Email' : '公司邮箱' }: </span> {this.state.email}
                            </p>
                        </Col>
                        <Col className={'p0'} md={3}>
                            <Row className={'pt10'}>
                                <a className={'mr5 pointer'} target='_blank' href={this.state.whatsapp}>
                                    <img width={20} src={whatsapp} alt="minajeans whatsapp"/>
                                </a> {this.state.whatsappUsername}
                            </Row>
                            <Row className={'pt10'}>
                                <a className={'mr5 pointer'} target='_blank' href={this.state.instagram}>
                                    <img width={20} src={instagram} alt="minajeans instagram"/>
                                </a> {this.state.instagramUsername}
                            </Row>
                            <Row className={'pt10'}>
                                <a className={'mr5 pointer'} target='_blank' href={this.state.wechat}>
                                    <img width={20} src={wechat} alt="minajeans wechat"/>
                                </a> {this.state.wechatUsername}
                            </Row>
                            <Row className={'pt10'}>
                                <a className={'mr5 pointer'} target='_blank' href={this.state.facebook}>
                                    <img width={20} src={facebook} alt="minajeans facebook"/>
                                </a> {this.state.facebookUsername}
                            </Row>
                        </Col>
                    </Row>
                </Col>
                <Col md={{span:10, offset:1}} className={'inline-pages-border'}>
                    <p className={'sub-footer text-center white'}>
                        {this.state.lang === 'en' ? 'Copyright 2020' : '版权2020' } <span>Minajeans.com</span>
                    </p>
                </Col>
            </Col>
        )
    }
}


export default footer

